// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../factories/translate-dialog";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import TranslateDialogViewModel from "./../factories/translate-dialog";
class MailTemplate extends BaseViewModel {

    constructor(tabPage: TabPage) {
        super(tabPage);
    }

    lastFocusedControl = null;

    Subject = ko.pureComputed<string>({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Subject1();
                case 2:
                    return this.Subject2();
                case 3:
                    return this.Subject3();
                case 4:
                    return this.Subject4();
                case 5:
                    return this.Subject5();
                case 6:
                    return this.Subject6();
                case 7:
                    return this.Subject7();
                case 8:
                    return this.Subject8();
                case 9:
                    return this.Subject9();
                case 10:
                    return this.Subject10();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Subject1(value);
                    break;
                case 2:
                    this.Subject2(value);
                    break;
                case 3:
                    this.Subject3(value);
                    break;
                case 4:
                    this.Subject4(value);
                    break;
                case 5:
                    this.Subject5(value);
                    break;
                case 6:
                    this.Subject6(value);
                    break;
                case 7:
                    this.Subject7(value);
                    break;
                case 8:
                    this.Subject8(value);
                    break;
                case 9:
                    this.Subject9(value);
                    break;
                case 10:
                    this.Subject10(value);
                    break;
            }
        }
    });
    Template = ko.pureComputed<string>({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Template1();
                case 2:
                    return this.Template2();
                case 3:
                    return this.Template3();
                case 4:
                    return this.Template4();
                case 5:
                    return this.Template5();
                case 6:
                    return this.Template6();
                case 7:
                    return this.Template7();
                case 8:
                    return this.Template8();
                case 9:
                    return this.Template9();
                case 10:
                    return this.Template10();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Template1(value);
                    break;
                case 2:
                    this.Template2(value);
                    break;
                case 3:
                    this.Template3(value);
                    break;
                case 4:
                    this.Template4(value);
                    break;
                case 5:
                    this.Template5(value);
                    break;
                case 6:
                    this.Template6(value);
                    break;
                case 7:
                    this.Template7(value);
                    break;
                case 8:
                    this.Template8(value);
                    break;
                case 9:
                    this.Template9(value);
                    break;
                case 10:
                    this.Template10(value);
                    break;
            }
        }
    });
    MailTemplateKey: KnockoutObservable<string> = ko.observable();
    Subject1: KnockoutObservable<string> = ko.observable();
    Subject2: KnockoutObservable<string> = ko.observable();
    Subject3: KnockoutObservable<string> = ko.observable();
    Subject4: KnockoutObservable<string> = ko.observable();
    Subject5: KnockoutObservable<string> = ko.observable();
    Subject6: KnockoutObservable<string> = ko.observable();
    Subject7: KnockoutObservable<string> = ko.observable();
    Subject8: KnockoutObservable<string> = ko.observable();
    Subject9: KnockoutObservable<string> = ko.observable();
    Subject10: KnockoutObservable<string> = ko.observable();
    Template1: KnockoutObservable<string> = ko.observable();
    Template2: KnockoutObservable<string> = ko.observable();
    Template3: KnockoutObservable<string> = ko.observable();
    Template4: KnockoutObservable<string> = ko.observable();
    Template5: KnockoutObservable<string> = ko.observable();
    Template6: KnockoutObservable<string> = ko.observable();
    Template7: KnockoutObservable<string> = ko.observable();
    Template8: KnockoutObservable<string> = ko.observable();
    Template9: KnockoutObservable<string> = ko.observable();
    Template10: KnockoutObservable<string> = ko.observable();

    AvailableVariables: TabPage;

    InitUrl() {
        return "MailTemplate/Init";
    }
    TranslateSubject() {
        var translateDialog = new TranslateDialogViewModel(this.Subject1, this.Subject2, this.Subject3, this.Subject4, this.Subject5);
        translateDialog.Open();
    }
    ;
    TranslateTemplate() {
        var translateDialog = new TranslateDialogViewModel(this.Template1, this.Template2, this.Template3, this.Template4, this.Template5);
        translateDialog.Open();
    }
    ;
    CompleteCheck() {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.MailTemplateKey())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    init() {
        return super.init().then(() => {
            //load tabs
            return super.InitTabController().then(() => {
                this.AvailableVariables = new TabPage('MailTemplateAvailableVariables');
                this.AvailableVariables.IsClosable(false);
                this.AvailableVariables.Url("MailTemplateAvailableVariables");
                this.AvailableVariables.AutoSelect = true;
                this.TabController.AddTab(this.AvailableVariables);
            });
        });
    }

    /*
   * Sets a variable for template or subject
   * */
    public SetVariable(value: string) {
        if (this.lastFocusedControl) {
            const index = this.lastFocusedControl.selectionStart;
            let prefixText = "";
            let suffixText = "";

            const textFunction = this.lastFocusedControl.id === 'mailTemplateTemplateControl' ? this.Template : this.Subject;
            let text: string = textFunction();
            if (text) {
                prefixText = text.substring(0, index);
                suffixText = text.substring(index, text.length);
            }
            text = prefixText + value + suffixText;
            textFunction(text);
        }
    }

    /*
     * Sets last focused control
     * */
    public SetFocusedControl(data: any, event: any) {
        this.lastFocusedControl = event.target;
    }
}
export default MailTemplate;